import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { Z_INDEX_HEADER } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  LOGO_POSITION,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

interface HeaderContainerProps {
  componentThemeName: string;
}

export const $HeaderContainer = styled('div')<HeaderContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX_HEADER};
  width: 100%;
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
  height: ${spacing(16)};
  background-color: ${({ theme, componentThemeName }) => {
    return getCustomComponentProperty({
      theme,
      componentName: componentThemeName,
      property: SUPPORTED_PROPERTIES.BACKGROUND_COLOR,
      fallback: theme.colors.white,
    });
  }};
  border-bottom: ${({ theme }) =>
    `${theme.borders.thickness} solid ${transparentize(
      0.75,
      theme.colors.default,
    )}`};
  margin-bottom: ${spacing('lg')};
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.06);
`;

export const $MenuContainer = styled.div<{ $position: LOGO_POSITION }>`
  position: relative;
  align-items: center;
  height: ${spacing(16)};
  display: flex;

  flex-direction: ${({ $position }) => {
    if ($position === LOGO_POSITION.RIGHT) {
      return 'row-reverse';
    }

    return 'row';
  }};

  justify-content: space-between;
`;

interface LogoContainerProps {
  componentThemeName: string;
  $isMobileView?: boolean;
}

export const $LogoContainer = styled('div')<LogoContainerProps>`
  display: flex;
  align-content: center;

  width: 100%;
  height: ${spacing(11)};
  cursor: pointer;
  padding: 0;
  position: ${({ componentThemeName, theme, $isMobileView }) => {
    if ($isMobileView) {
      return 'relative';
    }

    return getCustomComponentProperty({
      theme,
      componentName: componentThemeName,
      property: SUPPORTED_PROPERTIES.POSITION,
      fallback: 'relative',
    });
  }};
  text-align: ${({ componentThemeName, theme, $isMobileView }) => {
    if ($isMobileView) {
      return 'left';
    }

    return getCustomComponentProperty({
      theme,
      componentName: componentThemeName,
      property: SUPPORTED_PROPERTIES.TEXT_ALIGN,
      fallback: 'left',
    });
  }};
`;

export const $LogoImg = styled('img')`
  max-height: ${spacing(11)};
`;

export const $LogoutButton = styled(Button)`
  @media (max-width: 670px) {
    display: none;
  }
`;

export const $SmallLogoutButton = styled(Button)`
  display: none;
  @media (max-width: 670px) {
    display: block;
    width: initial;
    height: initial;
    line-height: 0;

    & > span {
      height: 100%;
    }
  }
`;

export const $ButtonCol = styled(Col)`
  @media (min-width: 670px) {
    display: flex !important;
    align-items: center !important;
  }
  @media (max-width: 670px) {
    padding: 0;
  }
`;

export const $HeaderCol = styled(Col)`
  @media (max-width: 670px) {
    max-width: 40%;
    flex-basis: 40%;
  }
`;

export const $LogoCol = styled(Col)`
  @media (max-width: 670px) {
    max-width: 60%;
    flex-basis: 60%;
  }
`;

export const $RightSide = styled.div`
  display: flex;
`;

export const $EmptyDiv = styled.div<{ $width: number }>`
  min-width: ${({ $width }) => ($width > 0 ? spacing(24) : '0')};
  width: ${({ $width }) => `${$width}px`};
  height: ${spacing('px')};
`;
